/** Max length for POST /owners/{owner_id}/setting `nick_name` (V2.8). */
export const OWNER_NICK_NAME_MAX_LENGTH = 64;
